// extracted by mini-css-extract-plugin
export default {"plans":"JoinPlanPage_plans__9ItZi","error":"JoinPlanPage_error__f2CdD"};